import { render, staticRenderFns } from "./CourtDetails.vue?vue&type=template&id=b15a6180&scoped=true&"
import script from "./CourtDetails.vue?vue&type=script&lang=js&"
export * from "./CourtDetails.vue?vue&type=script&lang=js&"
import style0 from "./CourtDetails.vue?vue&type=style&index=0&id=b15a6180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15a6180",
  null
  
)

export default component.exports